/*

Ashraf 11/27/2022 2698947782 Initial sub tabs for data repository
Poornima 12/01/2022 2698947782 UsageFieldList component imported

*/
import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AppContext from '../../../../components/contextProvider/AppContextProvider/AppContext';
import SearchDataRepositories from './SearchDataRepositories';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import SaveAlert from '../../../../components/DialogBox/SaveAlert';
import AddDataRepositoryForm from './AddDataRepositories';
import UsageFieldList from './UsageFielsList';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  demo1: {
    color: 'white',
    borderRadius: '6px',
  },
  searchButtons: {
    margin: '-8px 0 8px',
  },

  popup: {
    background: 'black',
  },
}));

export default function SubTabsContent({ setTableValue, StepperFieldList }) {
  const classes = useStyles();
  const [tabvalue, setTabValue] = useState(0);
  const [fieldListRowData, setFieldListRowData] = useState('');
  const [usageState, setUsageState] = useState(false);
  const { reportMasterId } = useContext(AppContext);
  const [isCopyData, setIsCopyData] = useState(false);
  const { setGlobalFieldRow, sample, setNewTabValue } = useContext(SelectTabContextProvider);
  const [rowSelected, setRowSelected] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (reportMasterId !== '') {
      setTabValue(1);
    }
  }, [reportMasterId]);

  // component render set Copy is false(2700799562)
  useEffect(() => {
    setIsCopyData(false);
  }, []);

  // set Tab value(2700799562)
  const handleChange = (event, newValue) => {
    if (tabvalue === 1 && sample && newValue === 0) {
      setOpen(true);
      setNewTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
    setGlobalFieldRow(false);
  };
  return (
    // Removed sub tabs (2700799562)
    <div className={classes.root}>
      <div className={classes.searchButtons}>
        {open && (
          <SaveAlert setTabValue={setTabValue} setOpen={setOpen} open={open} tabvalue={tabvalue} />
        )}
        {/* <AntTabs
          className={classes.demo1}
          value={tabvalue}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Search Field List" />
          <AntTab label="Add / View Field List" />
          {tabvalue === 2 && <AntTab label="Usage Field List" />}
        </AntTabs> */}
        <Typography />
      </div>
      <div className={classes.subContent}>
        {tabvalue === 0 ? (
          <SearchDataRepositories
            setFieldListRowData={setFieldListRowData}
            setTabValue={setTabValue}
            usageState={usageState}
            setUsageState={setUsageState}
            setRowSelected={setRowSelected}
            setIsCopyData={setIsCopyData}
            StepperFieldList={StepperFieldList}
          />
        ) : tabvalue === 1 ? (
          <AddDataRepositoryForm
            setTabValue={setTabValue}
            setUsageState={setUsageState}
            rowSelected={rowSelected}
            isCopyData={isCopyData}
            handleChange={handleChange}
            repositoryFields={true}
          />
        ) : tabvalue === 2 ? (
          <UsageFieldList
            fieldListRowData={fieldListRowData}
            setTabValue={setTabValue}
            setUsageState={setUsageState}
            rowSelected={rowSelected}
          />
        ) : null}
      </div>
    </div>
  );
}
